import { z } from 'my-zod'

export const GuestTypeEnum = z.enum(['Adult', 'MinorFamilyMember', 'UnaccompaniedMinor']).setEnumLabels({
  Adult: 'Adult',
  MinorFamilyMember: 'Minor Family Member',
  UnaccompaniedMinor: 'Unaccompanied Minor'
})

export type GuestTypeEnum = z.infer<typeof GuestTypeEnum>
export const GuestTypeOptions = Object.values(GuestTypeEnum.Values)
